<real-data-preview
	[ngBusy]="loading"
	[widget]="widget"
	[utils]="utils"
	[showTotalCount]="showTotalCount()"
	[trigger]="redrawTrigger"
	(updateDataLoading)="onDataLoading($event)"
	(updateChart)="updateChartSettings()"
></real-data-preview>
